import storage from './storage';
import { STORAGE_KEYS } from './constants';

/**
 * Check if user is logged in by checking access token
 */
export const isLoggedIn = (): boolean => {
  const accessToken = storage.get(STORAGE_KEYS.ACCESS_TOKEN);
  return !!accessToken;
};

/**
 * Get current user info from storage
 */
export const getCurrentUser = () => {
  return storage.get(STORAGE_KEYS.USER_INFO);
};

/**
 * Clear all authentication data
 */
export const clearAuth = () => {
  storage.remove(STORAGE_KEYS.ACCESS_TOKEN);
  storage.remove(STORAGE_KEYS.REFRESH_TOKEN);
  storage.remove(STORAGE_KEYS.USER_INFO);
  storage.remove(STORAGE_KEYS.CURRENT_WORKSPACE);
};

